import {
  filter,
  groupBy,
  pipe,
  sortBy,
} from 'lodash/fp';
import { createSelector } from 'reselect';
import {
  allGeographiesInternational,
  allIndicatorsInternational,
} from '../basic';
import { denormalize } from './';

const sort = sortBy('geography');

const filterOps = (level) =>
  filter(({ parent: { _id: needle } = {} } = {}) =>
    level.find(({ _id }) => needle === _id)
  );
const group = groupBy(({ parent: { _id } = {} } = {}) => _id);

const geographySelector = createSelector(
  allGeographiesInternational,
  ({ byId = {} } = {}) => {
    const levelOne = filter(({ parent = false }) => !parent)(byId);
    const levelTwo = filterOps(levelOne)(byId);
    const levelThree = filterOps(levelTwo)(byId);
    const levelFour = pipe([
      filterOps(levelThree),
      group,
    ])(byId);

    const groupedLevelThree = group(
      levelThree.map(({ _id, ...datum }) => ({
        ...datum,
        _id,
        children: sort(levelFour[_id]),
      }))
    );

    const groupedLevelTwo = group(
      levelTwo.map(({ _id, ...datum }) => ({
        ...datum,
        _id,
        children: sort(groupedLevelThree[_id]),
      }))
    );

    return levelOne.map(({ _id, ...datum }) => ({
      ...datum,
      _id,
      children: sort(groupedLevelTwo[_id]),
    }))
      .sort(({ geography: a }, { geography: b }) => {
        if ('world' === a.toLowerCase()) {
          return -1;
        }

        if ('world' === b.toLowerCase()) {
          return 1;
        }

        return a.localeCompare(b);
      });
  }
);

export default createSelector(
  geographySelector,
  allIndicatorsInternational,
  (geography, indicator) => ({
    geography,
    indicator: denormalize(indicator),
  })
);



// WEBPACK FOOTER //
// ./app/selectors/navigation/international.js